export function encryptBikData(data: string) {
  const key = 'phaedrus';
  let encryptedData = '';
  for (let i = 0; i < data.length; i++) {
    encryptedData += String.fromCharCode(
      data.charCodeAt(i) ^ key.charCodeAt(i % key.length),
    );
  }
  return encryptedData;
}

export function decryptBikData(encryptedData: string) {
  const key = 'phaedrus';
  let decryptedData = '';
  for (let i = 0; i < encryptedData.length; i++) {
    decryptedData += String.fromCharCode(
      encryptedData.charCodeAt(i) ^ key.charCodeAt(i % key.length),
    );
  }
  return decryptedData;
}
